export default [
  {
    name: 'en',
    text: 'English',
    soon: false
  },
  {
    name: 'ru',
    text: 'Русский',
    soon: false
  },
  {
    name: 'ua',
    text: 'Українська',
    soon: false
  },
  {
    name: 'pt',
    text: 'Português',
    soon: false
  },
  {
    name: 'cn',
    text: '中文',
    soon: false
  },
  {
    name: 'es',
    text: 'Español',
    soon: false
  },
  {
    name: 'vi',
    text: 'Tiếng Việt',
    soon: true
  },
  {
    name: 'th',
    text: 'ภาษาไทย',
    soon: true
  },
  {
    name: 'hi',
    text: 'हिन्दी',
    soon: true
  },
  {
    name: 'kk',
    text: 'Қазақша',
    soon: true
  },
  {
    name: 'fr',
    text: 'Français',
    soon: true
  },
  {
    name: 'de',
    text: 'Deutsch',
    soon: true
  }
]
